import React from 'react'
import { Filter } from '../../components/Filter'
import { Filters } from '../../config'

export const SinkFilter = ({}) => {
    return (
        <div className="p-6">
            <Filter
                filters={Object.values(Filters)}
                onChange={(...args: any[]) => console.log('onChange', args)}
                saveFilter={(...args: any[]) => console.log('saving filter', args)}
                deleteCustomFilter={(...args: any[]) => console.log('deleting custom filter', args)}
                editCustomFilter={(...args: any[]) => console.log('edit custom filter', args)}
                customFilters={[
                    {
                        type: 'number',
                        key: 'id',
                        name: 'test',
                    },
                ]}
            />
        </div>
    )
}
